module.exports = __webpack_public_path__ + "img/symbol-logo_fs_sinfondo.20cb0919.png";